import { useOfflineSync } from '../../hooks/useOfflineSync'
import { useToast } from './ToastProvider'

export function SyncStatusBar() {
  const { isOnline, syncing, pendingCount, syncPending } = useOfflineSync()
  const { addToast } = useToast()

  if (isOnline && pendingCount === 0) return null

  async function handleSync() {
    const result = await syncPending()
    if (result.success > 0) addToast(`${result.success} sincronizado(s)`, 'success')
    if (result.failed > 0) addToast(`${result.failed} falha(s)`, 'error')
  }

  return (
    <div
      className={`fixed bottom-4 right-4 z-50 flex items-center gap-3 rounded-xl px-4 py-3 shadow-lg border ${
        isOnline
          ? 'bg-yellow-50 border-yellow-200 text-yellow-800'
          : 'bg-red-50 border-red-200 text-red-800'
      }`}
    >
      <span className="text-lg">{isOnline ? '📤' : '📴'}</span>
      <div className="text-sm">
        {!isOnline ? (
          <span className="font-medium">Modo Offline</span>
        ) : pendingCount > 0 ? (
          <span className="font-medium">
            {pendingCount} pendente{pendingCount > 1 ? 's' : ''} para sincronizar
          </span>
        ) : null}
      </div>
      {isOnline && pendingCount > 0 && (
        <button
          onClick={handleSync}
          disabled={syncing}
          className="ml-2 px-3 py-1.5 bg-yellow-600 text-white text-xs font-semibold rounded-lg hover:bg-yellow-700 disabled:opacity-50 transition-colors"
        >
          {syncing ? 'Sincronizando...' : 'Sincronizar'}
        </button>
      )}
    </div>
  )
}
